module.exports = __webpack_public_path__ + "img/googleplayicon.529d60eb.529d60eb.svg";